import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TableInfoEffects } from './store/table-info.effects';
import * as fromTableInfo from './store/table-info.reducer';

export function provideTableInfoStore(): EnvironmentProviders {
    return importProvidersFrom(
        StoreModule.forFeature(
            fromTableInfo.TABLE_INFO_FEATURE_KEY,
            fromTableInfo.tableInfoReducer,
        ),
        EffectsModule.forFeature(TableInfoEffects),
    );
}
